export const mentionMixin = {

    getMentionableUsers() {
        const users = [];
        let participantIds = [];

        if (this.viewMode === 'dm') {
            participantIds = [this.dmState.otherUserId];
        } else if (this.viewMode === 'channel') {
            participantIds = this.channelState.participants;
        } else if (this.viewMode === 'thread') {
            participantIds = this.threadState.participants;
        }

        for (const id of participantIds) {
            if (String(id) === this.activeUserId) continue;
            const user = this.resolveUser(id);
            if (user && user.fullname !== 'Not Found') users.push(user);
        }

        return users;
    },

    detectMentionTrigger() {
        if (this._mentionOpenedByButton) {
            this._mentionOpenedByButton = false;
            return;
        }

        const selection = window.getSelection();
        if (!selection || !selection.isCollapsed || !selection.rangeCount) {
            this.closeMentionDropdown();
            return;
        }

        const range = selection.getRangeAt(0);
        let node = range.startContainer;
        let offset = range.startOffset;

        if (node.nodeType !== Node.TEXT_NODE) {
            if (node.childNodes.length && offset > 0) {
                const prev = node.childNodes[offset - 1];
                if (prev && prev.nodeType === Node.TEXT_NODE) {
                    node = prev;
                    offset = node.textContent.length;
                } else if (prev) {
                    const walker = document.createTreeWalker(prev, NodeFilter.SHOW_TEXT);
                    let last = null;
                    while (walker.nextNode()) last = walker.currentNode;
                    if (last) { node = last; offset = node.textContent.length; }
                }
            }
            if (node.nodeType !== Node.TEXT_NODE) {
                this.closeMentionDropdown();
                return;
            }
        }

        const textBeforeCursor = node.textContent.substring(0, offset);
        const match = textBeforeCursor.match(/(^|[\s])@([^\s@]*)$/);

        if (!match) {
            this.closeMentionDropdown();
            return;
        }

        const query = match[2];
        this.mentionQuery = query;
        this.filterAndShowMentions(query);
    },

    filterAndShowMentions(query) {
        const users = this.getMentionableUsers();
        const lowerQuery = query.toLowerCase();

        this.mentionFilteredUsers = users.filter(user =>
            user.fullname.toLowerCase().includes(lowerQuery)
        );

        if (!this.mentionFilteredUsers.length) {
            this.closeMentionDropdown();
            return;
        }

        this.mentionSelectedIndex = 0;
        this.renderMentionDropdown();
    },

    renderMentionDropdown() {
        if (!this.mentionDropdownEl) {
            this.mentionDropdownEl = document.createElement('div');
            this.mentionDropdownEl.className = 'mention-picker-popover';
            const composeBox = this.querySelector('.compose_box');
            if (composeBox) composeBox.append(this.mentionDropdownEl);
        }

        this.mentionDropdownEl.innerHTML = this.mentionFilteredUsers.map((user, index) => {
            const avatarUrl = user.avatar_128 || user.avatar_512;
            return `<div class="mention-picker__item ${index === this.mentionSelectedIndex ? 'mention-picker__item--active' : ''}" data-user-id="${user.user_id}">
                <gh-avatar-webcomponent name="${user.fullname}"${avatarUrl ? ` url="${avatarUrl}"` : ''}></gh-avatar-webcomponent>
                <span class="mention-picker__name">${user.fullname}</span>
            </div>`;
        }).join('');

        this.mentionDropdownEl.querySelectorAll('.mention-picker__item').forEach(item => {
            item.addEventListener('mousedown', (e) => {
                e.preventDefault();
                this.selectMention(String(item.dataset.userId));
            });
        });

        this.mentionDropdownEl.style.display = 'block';
        this.mentionDropdownOpen = true;
        this.positionMentionDropdown();
    },

    positionMentionDropdown() {
        const selection = window.getSelection();
        if (!selection || !selection.rangeCount || !this.mentionDropdownEl) return;

        const range = selection.getRangeAt(0);
        const caretRect = range.getBoundingClientRect();

        this.mentionDropdownEl.style.position = 'fixed';
        this.mentionDropdownEl.style.bottom = `${window.innerHeight - caretRect.top + 4}px`;
        this.mentionDropdownEl.style.zIndex = '1000';

        const popoverWidth = this.mentionDropdownEl.offsetWidth || 220;
        let left = caretRect.left;
        left = Math.max(8, Math.min(left, window.innerWidth - popoverWidth - 8));
        this.mentionDropdownEl.style.left = `${left}px`;
    },

    selectMention(userId) {
        const user = this.getMentionableUsers().find(u => String(u.user_id) === userId);
        if (!user) return;

        const selection = window.getSelection();
        if (!selection || !selection.rangeCount) return;

        const range = selection.getRangeAt(0);
        const node = range.startContainer;
        if (node.nodeType !== Node.TEXT_NODE) return;

        const textBeforeCursor = node.textContent.substring(0, range.startOffset);
        const match = textBeforeCursor.match(/(^|[\s])@([^\s@]*)$/);
        if (!match) return;

        const atStart = match.index + match[1].length;
        const textAfterCursor = node.textContent.substring(range.startOffset);

        const insertText = `@${user.fullname} `;
        node.textContent = textBeforeCursor.substring(0, atStart) + insertText + textAfterCursor;

        const newOffset = atStart + insertText.length;
        range.setStart(node, newOffset);
        range.setEnd(node, newOffset);
        selection.removeAllRanges();
        selection.addRange(range);

        this.pendingMentions.set(String(user.user_id), user.fullname);
        this.closeMentionDropdown();
        this.tuiEditor.focus();
        this.updateMentionHighlights();
    },

    closeMentionDropdown() {
        if (this.mentionDropdownEl) {
            this.mentionDropdownEl.style.display = 'none';
        }
        this.mentionDropdownOpen = false;
        this.mentionQuery = '';
        this.mentionFilteredUsers = [];
        this.mentionSelectedIndex = 0;
    },

    handleMentionKeydown(e) {
        if (!this.mentionDropdownOpen || !this.mentionFilteredUsers.length) return false;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            e.stopPropagation();
            this.mentionSelectedIndex = (this.mentionSelectedIndex + 1) % this.mentionFilteredUsers.length;
            this.updateMentionActiveItem();
            return true;
        }

        if (e.key === 'ArrowUp') {
            e.preventDefault();
            e.stopPropagation();
            this.mentionSelectedIndex = (this.mentionSelectedIndex - 1 + this.mentionFilteredUsers.length) % this.mentionFilteredUsers.length;
            this.updateMentionActiveItem();
            return true;
        }

        if (e.key === 'Enter' || e.key === 'Tab') {
            e.preventDefault();
            e.stopPropagation();
            const user = this.mentionFilteredUsers[this.mentionSelectedIndex];
            if (user) this.selectMention(String(user.user_id));
            return true;
        }

        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            this.closeMentionDropdown();
            return true;
        }

        return false;
    },

    updateMentionActiveItem() {
        if (!this.mentionDropdownEl) return;
        const items = this.mentionDropdownEl.querySelectorAll('.mention-picker__item');
        items.forEach((item, i) => {
            item.classList.toggle('mention-picker__item--active', i === this.mentionSelectedIndex);
        });

        const activeItem = items[this.mentionSelectedIndex];
        if (activeItem) activeItem.scrollIntoView({ block: 'nearest' });
    },

    extractMentionIds(markdown) {
        let content = markdown;
        const mentions = [];

        for (const [userId, fullname] of this.pendingMentions) {
            const escaped = fullname.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(`@${escaped}`, 'g');
            const replaced = content.replace(regex, `@${userId}`);
            if (replaced !== content) {
                content = replaced;
                mentions.push(userId);
            }
        }

        return { content, mentions };
    },

    clearMentionState() {
        this.pendingMentions.clear();
        this.closeMentionDropdown();
        this.updateMentionHighlights();
    },

    updateMentionHighlights() {
        if (!CSS.highlights) return;

        CSS.highlights.delete('mention-highlight');

        if (!this.pendingMentions.size) return;

        const container = this.querySelector('.toastui-editor-ww-container [contenteditable]');
        if (!container) return;

        const ranges = [];
        const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);

        while (walker.nextNode()) {
            const textNode = walker.currentNode;
            const text = textNode.textContent;

            for (const [, fullname] of this.pendingMentions) {
                const mention = `@${fullname}`;
                let pos = 0;
                let index;

                while ((index = text.indexOf(mention, pos)) !== -1) {
                    const range = new Range();
                    range.setStart(textNode, index);
                    range.setEnd(textNode, index + mention.length);
                    ranges.push(range);
                    pos = index + mention.length;
                }
            }
        }

        if (ranges.length) {
            CSS.highlights.set('mention-highlight', new Highlight(...ranges));
        }
    },

    insertAtSymbolAndOpenPicker() {
        if (!this.tuiEditor) return;
        this.tuiEditor.focus();
        this.tuiEditor.insertText('@');
        this.mentionQuery = '';

        const users = this.getMentionableUsers();
        if (!users.length) return;

        this.mentionFilteredUsers = users;
        this.mentionSelectedIndex = 0;
        this._mentionOpenedByButton = true;

        requestAnimationFrame(() => {
            this.renderMentionDropdown();
            const btn = this.querySelector('.compose_mention_btn');
            if (btn && this.mentionDropdownEl) {
                const btnRect = btn.getBoundingClientRect();
                this.mentionDropdownEl.style.bottom = `${window.innerHeight - btnRect.top + 4}px`;
                this.mentionDropdownEl.style.left = `${btnRect.left}px`;
            }
        });
    },
};
